import axios from 'axios'
import { getApiUrl } from 'Helpers'

type PoliticalFieldsAPIRequestType = {
  org_zip: string
  submitter_name: string
  submitter_address: string
  submitter_city: string
  submitter_state: string
  submitter_zip: string
  submitter_country: string
  audience_ids_targeted: string
  audience_description: string
  paid_for_by: string
  submitter_phone: string
}
type PoliticalTransparencyAPIRequestFieldType = {
  election_dates: string
  usfecid: string
  org_name: string
  org_address_1: string
  org_address_2?: string
  org_city: string
  org_region: string
  org_postal_code: string
  org_country: string
  org_phone_code: string
  org_phone: string
  treasurer_name: string
  payment_method_type: string
  political_objective: string
  payment_method_other: string
  is_expenditure_committee: boolean
  is_accuracy_acknowledged: boolean
  government_level?: string
}

export const setPoliticalFieldsAndForm = async (
  campaignId: string,
  orgId: string,
  politicalTransparency: PoliticalTransparencyAPIRequestFieldType,
  politicalFields: PoliticalFieldsAPIRequestType,
  file?: File,
  state?: string,
  token?: string,
) => {
  const formData = new FormData()

  // Add form fields
  formData.append('campaign_id', campaignId)
  formData.append('org_id', orgId)
  formData.append(
    'political_transparency',
    JSON.stringify(politicalTransparency),
  )
  formData.append('political_fields', JSON.stringify(politicalFields))
  // Add file (passed as parameter)
  if (file && state && state !== 'none') {
    formData.append('file', file)
    formData.append('state', state)
  }
  const url = getApiUrl()

  try {
    const response = await axios.post(
      `${url}/v1/campaigns/political-form`,
      formData,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  } catch (error) {
    throw error
  }
}
